import React, { useState, useEffect } from "react";
import CardLaneScore from "../components/cardLaneScore/cardLaneScore";
import styles from "./styles.module.scss";
import TableLastFrame from "../components/tablesFrame/tableLastFrame";
import { useStoreon } from "storeon/react";
import { RESET_PLAYER, CLEAR_SCORECARD, HIDE_LANE } from "../../store/players";
import TableFrame from "../components/tablesFrame/tableFrame";
import CardByLane from "../components/cardByLane/cardByLane";
import TopLowFrame from "../components/tablesByLane/topLowFrame";
import LastFrameCurrent from "../components/tablesByLane/lastFrame/lastFrameCurrent";
import { LOAD_GENERAL_SETTINGS } from "../../store/generalSettings";
import { LOAD_SETTINGS_TABLES } from "../../store/tableSettings";
import { LOAD_SETTINGS_CARD } from "../../store/scoreCardSettings";
import { useHistory } from "react-router-dom";
import { fetchBC } from "../../services/bowlingCenterService";
import { SET_SETUP_TYPE } from "../../store/setupType";

const LiveScorePlayers = () => {
  const [bowlingCenters, setBowlingCenters] = useState([]);
  const {
    dispatch,
    players,
    tableSettings,
    generalSettings,
    scoreCardSettings,
    setupType,
    auth,
    timersScoreCards,
  } = useStoreon(
    "players",
    "tableSettings",
    "generalSettings",
    "setupType",
    "mainHeaderSettings",
    "scoreCardSettings",
    "timersScoreCards",
    "scoreCardToHide"
  );

  const { scoreCardToHide, lastPlayerUpdated } = timersScoreCards;
  const history = useHistory();

  const [timerClearScoreCard, setTimerClearScoreCard] = useState(null);
  const [timerHideScoreCard, setTimerHideScoreCard] = useState(null);
  const [bowlingCentersSetting, setBowlingCentersSetting] = useState([]);
  const [bowlingCentersList, setBowlingCentersList] = useState([]);
  const [refresh, setRefresh] = useState(true);

  useEffect(() => {
    if (
      bowlingCentersList.length &&
      bowlingCentersSetting.length &&
      bowlingCentersSetting.length
    ) {
      const newData = bowlingCentersSetting.map((item, i) => {
        const bcIndex = bowlingCentersList.findIndex(
          (i) => i.uuid === item.uuid
        );

        return {
          uuid: item.uuid ? item.uuid : null,
          lane: item.lane ? item.lane : null,
          player: item.player ? item.player : "",
          playerNumber: item.playerNumber ? item.playerNumber : null,
          displayName: item.displayName ? item.displayName : "",
          bowlingCenterName:
            bcIndex > -1 ? bowlingCentersList[bcIndex].companyName : "",
          group: item.group ? item.group : null,
        };
      });

      const size = newData.length;
      const remainArray = size < 12 ? new Array(12 - size).fill(null) : [];

      setBowlingCenters([...newData, ...remainArray]);
      localStorage.setItem(
        "bowlingCentersList",
        JSON.stringify([...newData, ...remainArray])
      );
      setRefresh(false);
      setTimeout(() => {
        setRefresh(true);
      }, 0);
    }
  }, [bowlingCentersList, bowlingCentersSetting]);

  useEffect(() => {
    if (scoreCardToHide) {
      dispatch(HIDE_LANE, {
        bowlingCenterUUID: scoreCardToHide.bowlingCenterUUID,
        lane: scoreCardToHide.lane,
      });
    }
  }, [scoreCardToHide]);

  useEffect(() => {
    fetchBC().then((data) => setBowlingCentersList(data));

    const baseApiUrl =
      process.env.REACT_APP_API_LOGIN_URL ||
      "https://api-dev-scoringcapture.lanetalk.com/v1";

    const sse = new EventSource(`${baseApiUrl}/events?stream=messages`);

    function getRealtimeData(data) {
      if (data && data.data.length) {
        const newData = data.data.map((item, i) => {
          return {
            uuid: item.bowlingcenter_uuid ? item.bowlingcenter_uuid : null,
            lane: item.lane_number ? item.lane_number : null,
            player: item.player_name ? item.player_name : "",
            playerNumber: item.player_number ? item.player_number : null,
            displayName: item.display_name ? item.display_name : "",
            bowlingCenterName: "",
            group: item.group ? item.group : null,
          };
        });

        setBowlingCentersSetting([...newData]);

        if (data.type === 1) {
          dispatch(SET_SETUP_TYPE, "By Lane");
        } else {
          dispatch(SET_SETUP_TYPE, "By Player");
        }
      }
    }
    sse.onmessage = (e) => getRealtimeData(JSON.parse(e.data));
    sse.onerror = (e) => {
      console.log("error", e);
    };

    return () => {
      if (timerClearScoreCard) {
        clearTimeout(timerClearScoreCard);
        setTimerClearScoreCard(null);
      }

      if (timerHideScoreCard) {
        clearTimeout(timerHideScoreCard);
        setTimerHideScoreCard(null);
      }

      sse.close();
    };
  }, []);

  useEffect(() => {
    if (lastPlayerUpdated) {
      const finish = isGameFinished(
        players.filter((player) => {
          return (
            player.bowlingCenterUuid === lastPlayerUpdated.bowlingCenterUuid &&
            player.lane === lastPlayerUpdated.lane
          );
        })
      );

      if (players.length && finish) {
        setTimerClearScoreCard(
          setTimeout(() => {
            dispatch(CLEAR_SCORECARD, {
              bowlingCenterUuid: lastPlayerUpdated.bowlingCenterUuid,
              lane: lastPlayerUpdated.lane,
            });
            clearTimeout(timerClearScoreCard);
            setTimerClearScoreCard(null);
          }, 45000)
        );
      } else {
        if (timerClearScoreCard) {
          clearTimeout(timerClearScoreCard);
          setTimerClearScoreCard(null);
        }
      }
    }
  }, [lastPlayerUpdated]);

  const throwsEnd = (throws) => {
    if (throws.length === 0) {
      return false;
    }

    if (throws.length === 21) {
      return true;
    }

    if (throws.length === 20) {
      return !(throws[18] === "X" || throws[19] === "X" || throws[19] === "/");
    }

    return false;
  };

  const isGameFinished = (array) => {
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      if (!throwsEnd(element.throws)) {
        return false;
      }
    }

    return true;
  };

  useEffect(() => {
    const listBC = localStorage.getItem("bowlingCentersList");
    listBC && setBowlingCenters(JSON.parse(listBC));
    dispatch(LOAD_GENERAL_SETTINGS, { history });
    dispatch(LOAD_SETTINGS_TABLES, auth);
    dispatch(LOAD_SETTINGS_CARD, { history });
  }, [auth, dispatch]);

  useEffect(() => {
    dispatch(RESET_PLAYER);
  }, [bowlingCenters, dispatch]);

  const getPlayersPreview = (numberOfPlayers = 1) => {
    const playerPreview = {
      activePlayer: false,
      active_player: false,
      game: 0,
      lane: 0,
      playerHcp: 0,
      playerName: "",
      playerNumber: 0,
      scoreCompletedGames: 0,
      teamHcp: 0,
      teamName: "",
      pins: [],
      scores: [],
      speed: [],
      throws: [],
      player_number: 0,
    };
    const playersPreview = new Array(numberOfPlayers).fill(playerPreview);
    return playersPreview;
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.bodyContainer}>
        <div className={styles.liveScoringCards}>
          {refresh &&
            bowlingCenters
              .filter((e) => e && e.uuid)
              .map((bowlingCenter, index) => {
                return bowlingCenter && setupType === "By Player" ? (
                  <CardLaneScore
                    bowlingCenterInput={bowlingCenter}
                    key={index}
                    cardStyles={scoreCardSettings[1].settings}
                  />
                ) : (
                  bowlingCenter && (
                    <CardByLane
                      bowlingCenterInput={bowlingCenter}
                      key={index}
                      cardStyles={scoreCardSettings[0].settings}
                      playersPreview={getPlayersPreview(
                        +bowlingCenter.playerNumber
                      )}
                    />
                  )
                );
              })}
        </div>
        {setupType === "By Player" && (
          <div className={styles.containerTables}>
            {generalSettings.list_players_top && (
              <TableFrame
                players={players}
                tableStyles={tableSettings}
                title={"List of Players with Top Frame"}
              />
            )}
            {generalSettings.list_players_top_low && (
              <TableFrame
                players={players}
                tableStyles={tableSettings}
                showLow={true}
                title={"List of players with Top and Low Frame"}
              />
            )}
            {generalSettings.list_players_last_three && (
              <TableLastFrame
                players={players}
                tableStyles={tableSettings}
                title={" List of players with Last 3 Frames"}
              />
            )}
          </div>
        )}

        {setupType === "By Lane" && (
          <div className={styles.containerTables}>
            {generalSettings.list_players_top && (
              <TopLowFrame
                players={players}
                title={"List of Players with Top Frame"}
              />
            )}
            {generalSettings.list_players_top_low && (
              <TopLowFrame
                players={players}
                showLow={true}
                title={"List of players with Top and Low Frame"}
              />
            )}
            {generalSettings.list_players_last_three && (
              <LastFrameCurrent
                players={players}
                title={" List of players with Last 3 Frames"}
              />
            )}
          </div>
        )}
      </div>
      <div
        className={styles.backgroundImage}
        style={{
          backgroundImage:
            generalSettings.type === "image"
              ? `url(${encodeURI(generalSettings.image)}) `
              : "",
          backgroundColor: generalSettings.color,
        }}
      ></div>
    </div>
  );
};
export default LiveScorePlayers;
